import { Show, createSignal } from "solid-js";
import type { AdminApi, AdminInfo } from "./api";

export function LoginView(props: { api: AdminApi; notice: string; onLoggedIn: (admin: AdminInfo, recoveryCodesLeft?: number) => void }) {
  const [step, setStep] = createSignal<"password" | "code">("password");
  const [challenge, setChallenge] = createSignal("");
  const [busy, setBusy] = createSignal(false);
  const [error, setError] = createSignal("");
  let email!: HTMLInputElement;
  let password!: HTMLInputElement;
  let code!: HTMLInputElement;

  const submitPassword = async (event: SubmitEvent) => {
    event.preventDefault();
    setBusy(true);
    setError("");
    try {
      const result = await props.api.login(email.value.trim(), password.value);
      password.value = "";
      setChallenge(result.challengeToken);
      setStep("code");
    } catch (cause) {
      setError(cause instanceof Error ? cause.message : "Anmeldung fehlgeschlagen");
    } finally {
      setBusy(false);
    }
  };

  const submitCode = async (event: SubmitEvent) => {
    event.preventDefault();
    setBusy(true);
    setError("");
    try {
      const result = await props.api.verify(challenge(), code.value);
      props.onLoggedIn(result.admin, result.recoveryCodesLeft);
    } catch (cause) {
      setError(cause instanceof Error ? cause.message : "Anmeldung fehlgeschlagen");
      code.value = "";
    } finally {
      setBusy(false);
    }
  };

  return (
    <div class="adm-center">
      <div class="adm-card adm-login">
        <h1>Reflexo Admin</h1>
        <p class="adm-sub">Nur für Plattform-Administratoren.</p>
        <Show when={props.notice}><div class="adm-info" role="status">{props.notice}</div></Show>
        <Show when={step() === "password"} fallback={
          <form onSubmit={submitCode}>
            <label class="adm-field">
              <span>Code aus der Authenticator-App</span>
              <input ref={code} class="adm-input" inputmode="text" autocomplete="one-time-code" autofocus required placeholder="6 Ziffern oder Notfall-Code" />
            </label>
            <button class="adm-btn adm-full" type="submit" disabled={busy()}>Anmelden</button>
            <p class="adm-sub" style={{ "margin-top": "12px" }}>Ohne App? Gib stattdessen einen Notfall-Code ein. Er gilt nur einmal.</p>
          </form>
        }>
          <form onSubmit={submitPassword}>
            <label class="adm-field"><span>E-Mail</span><input ref={email} class="adm-input" type="email" autocomplete="username" required /></label>
            <label class="adm-field"><span>Passwort</span><input ref={password} class="adm-input" type="password" autocomplete="current-password" required /></label>
            <button class="adm-btn adm-full" type="submit" disabled={busy()}>Weiter</button>
          </form>
        </Show>
        <Show when={error()}><p class="adm-error" role="alert">{error()}</p></Show>
      </div>
    </div>
  );
}
